import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoggerService } from '../common/logger.service';
import { CORE_CONFIGURATION } from '../configuration';
import { Store } from '@ngxs/store';
import { SessionState, SessionStateModel } from '../session';

@Injectable({
  providedIn: 'root',
  deps: [Store, Router, LoggerService, CORE_CONFIGURATION],
})
export class AuthGuard  {
  constructor(
    private store: Store,
    private router: Router,
    private logger: LoggerService,
    @Inject(CORE_CONFIGURATION) private config,
  ) {
  }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.config.isInEditor) {
      return true;
    }

    const { currentItem }: SessionStateModel = this.store.selectSnapshot(SessionState);
    this.logger.group(
      `Auth Guard: Status(${currentItem})`,
      currentItem,
    );

    if (currentItem && currentItem.type) {
      return true;
    } else {
      this.logger.datadog(new Error('current Item is not available anymore or it is incomplete'), currentItem);
    }

    this.router.navigate([this.config.errorPageAccessDenied]);

    return false;
  }
}
